// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image {\n  width: 100px;\n  height: 100px;\n  margin: 5px;\n}\n.image img {\n    max-width: 100%;\n    display: block;\n    margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
